<template>
  <v-container fluid class="entity-index">

    <div class="mb-3">
      <slot name="actions">
      </slot>
    </div>

    <slot name="filter">
    </slot>

    <v-data-table class="entity-table elevation-1"
                  v-if="$vuetify.breakpoint.name !== 'xs'"
                  show-select
                  v-model="selected"
                  :item-class="itemClass"
                  :headers="tableHeaders"
                  :item-key="itemKey"
                  :items="tableRows"
                  :loading="loading"
                  :loading-text="$t('entityTable.loadingInProgress')"
                  :no-data-text="noDataText"
                  :options.sync="tableOp"
                  :server-items-length="totalCount"
                  :footer-props="{
          itemsPerPageOptions:[20, 30, 50, 100],
          itemsPerPageText: $t('entityTable.pagination.rowsOnPage'),
          pageText: currentPageNumberText }"
                  @contextmenu:row="rowRightClickHandler">

      <template v-for="(index, name) in $scopedSlots" v-slot:[name]="data">
        <slot :name="name" v-bind="data"></slot>
      </template>


      <template v-slot:item.rowActions="{ item }">
        <entity-table-row-end-action-menu
            class="text-end"
            :disabled="loading"
            :actions="item.rowActions"
        />
      </template>
      <template v-slot:footer>
        <div class="v-data-footer justify-start">
          <entity-table-selected-rows-action-menu :actions="selectedRowsActions"/>
        </div>
      </template>

    </v-data-table>

    <v-container class="max-width pa-0"
                 v-if="$vuetify.breakpoint.name === 'xs'">
      <v-list>
        <slot v-for="item in tableRows"
              name="entityListItem"
              :item="item"/>
        <v-list-item v-if="tableRows.length === 0 ">
          <v-list-item-content>
            <v-list-item-title><span class="text--secondary">{{ noDataText }}</span></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-pagination
          v-model="tableOptions.page"
          class="mt-1"
          :length="pageCount"
      ></v-pagination>
    </v-container>

  <entity-action-context-menu ref="entityActionContextMenu"/>

  </v-container>

</template>

<style scoped>

</style>

<script>
import EntityTableSelectedRowsActionMenu from '@/components/entity-crud/EntityTableSelectedRowsActionMenu';
import EntityTableRowEndActionMenu from '@/components/entity-crud/EntityTableRowEndActionMenu';
import i18n from '@/i18n';
import EntityActionContextMenu from '@/components/entity-crud/EntityActionContextMenu';

export default {
  components: {
    EntityActionContextMenu,
    EntityTableSelectedRowsActionMenu,
    EntityTableRowEndActionMenu,
  },
  name: 'EntityIndex',

  props: {
    loading: {
      type: Boolean,
      required: true,
    },
    totalCount: {
      type: Number,
      required: true,
    },
    itemKey: {
      type: String,
      required: true,
    },
    tableHeaders: {
      type: Array,
      required: true,
    },
    tableRows: {
      type: Array,
      required: true,
    },
    tableOptions: {
      type: Object,
      required: true,
    },
    selectedRows: {
      type: Array,
      required: true,
    },
    selectedRowsActions: {
      type: Array,
      required: true,
    },

    noDataText: {
      type: String,
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    getKey(item) {
      let value = item;
      this.itemKey.split('.').forEach(key => {
        value = value[key];
      });
      return value;
    },
    itemClass(item) {
      if (item.deleted) {
        return 'deleted';
      }
      return null;
    },

    rowRightClickHandler(event, item){
      console.log('right click ' + item);
      this.$refs.entityActionContextMenu.show(event, item.item.rowActions);
    },
  },
  computed: {
    tableOp: {
      get() {
        return this.tableOptions;
      },
      set(value) {
        this.$emit('update:tableOptions', value);
      },
    },
    selected: {
      get() {
        return this.selectedRows;
      },
      set(value) {
        this.$emit('update:selectedRows', value);
      },
    },

    pageCount() {
      return Math.ceil(this.totalCount / this.tableOptions.itemsPerPage);
    },
    currentPageNumberText() {
      const currentPage = this.tableOptions.page;
      return i18n.t('entityTable.pagination.page', { page: currentPage, pages: this.pageCount });
    },
  },
};
</script>
<style>
.entity-table tr.deleted > td > a,
.entity-table tr.deleted > td {
  color: red !important;
}


</style>
